import { Box, IconButton } from "@material-ui/core";
import CropFreeIcon from "@material-ui/icons/CropFree";
import React from "react";
import { FunctionField, useTranslate } from "react-admin";

/**
 * Renders the pallet SSCC value next to a barcode icon that opens the
 * barcode dialog. Designed to be used inside <CopyableWrapper source="sscc">
 * so the field also supports click-to-copy.
 */
export const SsccFieldWithBarcode = ({
	setBarcodeValue,
	setBarcodeTitle,
	setBarcodeDialogOpen,
	titleKey = "tab.pallets.pallet_id",
	...rest
}) => {
	const translate = useTranslate();
	const hasBarcodeDialog = setBarcodeValue && setBarcodeTitle && setBarcodeDialogOpen;
	return (
		<FunctionField
			{...rest}
			render={(record) => {
				if (!record?.sscc) return null;
				return (
					<Box display="flex" alignItems="center" gap={1}>
						{record.sscc}
						{hasBarcodeDialog && (
							<IconButton
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									setBarcodeValue(record.sscc);
									setBarcodeTitle(`${translate(titleKey)}: ${record.id}`);
									setBarcodeDialogOpen(true);
								}}
								style={{ padding: 4 }}
							>
								<CropFreeIcon fontSize="small" />
							</IconButton>
						)}
					</Box>
				);
			}}
		/>
	);
};
